export const clearFilterSessionStorage = () => {
  const filterKeys = [
    "selectedTime",
    "selectedRoomTypes",
    "selectedMunicipality",
    "selectedPriceRange",
    "selectedAreaRange",
    "selectedMoms",
    "vakansa-search-term",
    "selectedZones",
  ];

  filterKeys.forEach((key) => sessionStorage.removeItem(key));
};
